import React from 'react';
import styles from './Dropdown.module.scss';

const DropDown = ({ label, name, required = false, options = [], ...props }) => {
  return (
    <div className={styles.formGroup}>
      <label htmlFor={name}>
        {label}
        {required && '*'}
      </label>
      <select id={name} name={name} required={required} {...props}>
        <option value=''>Select...</option>
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DropDown;
